import { render, staticRenderFns } from "./ModalImportFile.vue?vue&type=template&id=c24c744c&scoped=true"
import script from "./ModalImportFile.vue?vue&type=script&lang=js"
export * from "./ModalImportFile.vue?vue&type=script&lang=js"
import style0 from "./ModalImportFile.vue?vue&type=style&index=0&id=c24c744c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c744c",
  null
  
)

export default component.exports